import React from "react";

const About = () => {
  return (
    <div className="pt-20 bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20">
          {/* Left Content */}
          <div>
            <div>
              <h2 className="text-4xl font-light text-gray-800">
                Personalized, Professional Accounting
              </h2>
              <div className="w-16 h-0.5 bg-gray-800 mt-8 mb-12"></div>
            </div>
            <div className="space-y-8">
              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  About the Founder
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  Yoel Alvarez, founder of Tax Solutions AS, holds a Bachelor's
                  Degree in Accounting and has over 10 years experience in
                  accounting, tax, and business development. Since 2014, he has
                  been assisting hundreds of clients annually with tax
                  preparation and financial statements. In 2021, he established
                  Tax Solutions SA to expand his commitment to exceptional
                  service and compliance.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  Our Mission
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  Simplify the complexities of tax requirements by offering
                  professional, reliable guidance, allowing you to focus on what
                  matters most to your business. By understanding each client's
                  unique financial needs, we provide tailored solutions that
                  ensure accuracy, efficiency, and peace of mind during tax
                  season and beyond.
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold text-gray-800 mb-4">
                  Our Vision
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  Dedicated to delivering comprehensive, forward-thinking
                  solutions powered by technology. We focus on building lasting
                  client relationships and fostering a collaborative,
                  people-centered company culture.
                </p>
              </div>
            </div>
          </div>

          {/* Right Content - Image with Animation */}
          <div className="fl-module fl-module-photo fl-animation fl-fade-right flex justify-end">
            <div className="w-[520px] h-[800px]">
              <div className="w-full h-full relative">
                <img
                  src="/bw_hd_aboutus.jpg"
                  alt="Professional"
                  className="w-full h-full object-cover grayscale"
                  style={{
                    clipPath:
                      'path("M200,0 H516 Q520,0 520,4 V517 Q520,521 516,521 H4 Q0,521 0,517 V200 Q0,0 200,0 Z")',
                    filter: "drop-shadow(5px 5px 20px rgba(0, 0, 0, 0.25))",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
